import { SxProps, Typography } from '@mui/material'
import React from 'react'
import FlexBox from '../flexBox/FlexBox'
import { TagProps } from './_props'
import sxs from './Tag.sxs'
import { mergeSx } from '../../../theme/_utils'

const Tag: React.FC<TagProps> = ({ label, color, icon, background, rounded }) => {
    const contentSxs: SxProps = {
        background,
        '& *': {
            color: `${color} !important`,
        },
    }

    const merged = mergeSx([sxs.tag, contentSxs, rounded ? sxs.tagRounded : undefined])

    return (
        <FlexBox justifyContent="center" alignItems="center" sx={merged}>
            {icon}
            <Typography sx={sxs.tagLabel}>{label}</Typography>
        </FlexBox>
    )
}

export default Tag
